import styles from "../../../styles/Components/bot/bot-reports/SharePdf.module.css";
import { AiOutlineShareAlt } from "react-icons/ai";
import { useState } from "react";
import { message, Modal } from "antd";
import { MdOutlineContentCopy } from "react-icons/md";
import {
  FaFacebookF,
  FaTelegram,
  FaTwitter,
  FaWhatsapp,
  FaShareAlt,
} from "react-icons/fa";

function SharePdf({ link }) {
  const [openModal, setOpenModal] = useState(false);

  const shareText = "Check out my performance report in CryptoCrispy:";

  const copyHandler = async (text, type = "link") => {
    try {
      await navigator.clipboard.writeText(text);
      message.success(`Copied ${type} to clipboard`);
    } catch (err) {
      message.error("Failed to copy to clipboard");
    }
  };

  const shareHandlers = {
    facebook: () => {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
        "_blank",
      );
    },
    twitter: () => {
      window.open(
        `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          shareText,
        )}&url=${encodeURIComponent(link)}`,
        "_blank",
      );
    },
    telegram: () => {
      window.open(
        `https://t.me/share/url?url=${encodeURIComponent(
          link,
        )}&text=${encodeURIComponent(shareText)}`,
        "_blank",
      );
    },
    whatsapp: () => {
      window.open(
        `https://wa.me/?text=${encodeURIComponent(`${shareText} ${link}`)}`,
        "_blank",
      );
    },
  };

  return (
    <>
      <span
        className={styles.shareBtn}
        onClick={() => setOpenModal(true)}
        title="Share PDF"
        aria-label="Share PDF"
      >
        <AiOutlineShareAlt size={18} />
      </span>

      {openModal && (
        <Modal
          open={openModal}
          onCancel={(e) => {
            e.stopPropagation();
            setOpenModal(false);
          }}
          centered
          footer={null}
          width={400}
          className={styles.modal}
          maskClosable={false}
        >
          <h2 className={styles.title}>
            <FaShareAlt color="#0c4cfc" style={{ marginRight: "17px" }} />
            Share your performance report:
          </h2>

          <div
            className={styles.linkContainer}
            onClick={() => copyHandler(link)}
          >
            <p className={styles.link}>{link}</p>
            <span className={styles.copyIcon}>
              <MdOutlineContentCopy size={18} />
            </span>
          </div>

          <div className={styles.shareOption}>
            <p className={styles.shareTitle}>Share via:</p>
            <div className={styles.shareButtons}>
              <button
                className={`${styles.shareButton} ${styles.facebook}`}
                onClick={shareHandlers.facebook}
              >
                <FaFacebookF size={18} />
              </button>
              <button
                className={`${styles.shareButton} ${styles.twitter}`}
                onClick={shareHandlers.twitter}
              >
                <FaTwitter size={18} />
              </button>
              <button
                className={`${styles.shareButton} ${styles.telegram}`}
                onClick={shareHandlers.telegram}
              >
                <FaTelegram size={18} />
              </button>
              <button
                className={`${styles.shareButton} ${styles.whatsapp}`}
                onClick={shareHandlers.whatsapp}
              >
                <FaWhatsapp size={18} />
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default SharePdf;
